import { createContext } from "react";

interface ContextState {
    mobileMenu?: boolean;
    setMobileMenu?: any;
    clicked?: any;
    setClicked?: any;
}

export const mobileMenuContext = createContext({} as ContextState);
export const exploreContext = createContext({} as ContextState);
